import {CursorBasedPaginationResponse, QueryBaseTypeWithCursorPaginationWhereAndOrder} from 'api/common';

export interface LookUpModel {
    id: string;
    title: string;
    type: string;
    data: string;
    category: string;
    parentId?: string | null;
    description?: string;
    active: boolean;
}

export interface lookUpCreateUpdateModel extends Omit<LookUpModel, 'id'> {
    id?: string;
}

export interface LookUpsPaginationResponse {
    lookUps: CursorBasedPaginationResponse<LookUpModel>;
}
export interface LookupListingRequest extends QueryBaseTypeWithCursorPaginationWhereAndOrder<LookUpModel> {}

export enum LookupCategoryTypes {
    BoardType = 'BoardType',
    WorkspaceType = 'WorkspaceType',
    ReminderType = 'ReminderType',
    CommentType = 'CommentType',
    AppEventTrigger = 'AppEventTriiger',
}

export const LookupCategoryDescriptions: Record<LookupCategoryTypes, string> = {
    [LookupCategoryTypes.BoardType]: 'BoardType',
    [LookupCategoryTypes.WorkspaceType]: 'WorkspaceType',
    [LookupCategoryTypes.ReminderType]: 'ReminderType',
    [LookupCategoryTypes.CommentType]: 'CommentType',
    [LookupCategoryTypes.AppEventTrigger]: 'AppEventTrigger',
};
